var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsFileDropping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_718",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#44580a",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18839",
    "data-name": "Group 18839",
    transform: "translate(-1150 -397)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1150, 397)",
    filter: "url(#Ellipse_718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_718-2",
    "data-name": "Ellipse 718",
    transform: "translate(9 6)",
    fill: "#8bb611",
    stroke: "rgba(0,0,0,0.06)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15672",
    "data-name": "Path 15672",
    d: "M-5.356-11.736-1.9-15.194V.422A1.266,1.266,0,0,0-.633,1.687H.633A1.266,1.266,0,0,0,1.9.422V-15.194l3.458,3.458a1.266,1.266,0,0,0,1.79,0l.895-.895a1.266,1.266,0,0,0,0-1.79L.895-21.567a1.266,1.266,0,0,0-1.79,0l-7.146,7.146a1.266,1.266,0,0,0,0,1.79l.895.895A1.266,1.266,0,0,0-5.356-11.736Z",
    transform: "translate(1188.5 442.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsFileDropping);
export default __webpack_public_path__ + "static/media/xls-file-dropping.8c8796321f3a6bf4baa0b054a08abf12.svg";
export { ForwardRef as ReactComponent };